import { createSelector } from 'reselect'

export const getPhotosUploading = createSelector(
  state => state && state.ads && state.ads.shared && state.ads.shared.photosUploading,
  isUploading => isUploading
)
